/**
 * a collection of useful date utilities
 * @module utils/date
 */
import moment from 'moment-timezone';

// Pt time zone string
const LOCAL_TIME = 'America/Los_Angeles';
const DEFAULT_PT_FORMAT = 'YYYY-MM-DD hh:mm:ss a z';

/**
 * converts Utc date time string in Pt date time string in a given format
 * @param {string} val - Utc date time string
 * @param {string} format - format of expected string
 * @returns {string} Pt date time string
 */
export const utcToPtDateString = function utcToPtDateStringFunc(
  val,
  format = DEFAULT_PT_FORMAT
) {
  return moment.tz(val, LOCAL_TIME).format(format);
};

/**
 * converts Pt date time string in Utc date time string
 * @param {string} val - Pt date time string
 * @returns {string} Utc date time string
 */
export const ptToUtcDateString = function ptToUtcDateStringFunc(val) {
  const pt = moment.tz(val, LOCAL_TIME);
  const utc = pt.utc();
  return utc.format();
};

/**
 * converts Pt date time string in Utc date object
 * @param {string} val - Pt date time string
 * @returns {object} Utc date object
 */
export const ptDateStringToUtcDate = function ptDateStringToUtcDateFunc(val) {
  return moment.tz(val, LOCAL_TIME).utc();
};
